var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSberpay2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2344 9.80289C14.4528 10.0878 14.6376 10.3974 14.7852 10.7254L10.5979 13.8408L8.8479 12.7336V11.4016L10.5979 12.5088L14.2344 9.80289Z",
    fill: "#21A038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.062 12.6398C7.062 12.5801 7.06344 12.5207 7.06633 12.4617L6.00578 12.4092C6.00217 12.4857 6 12.563 6 12.6409C5.99955 13.25 6.11826 13.8532 6.34931 14.4159C6.58037 14.9786 6.91923 15.4897 7.34645 15.9199L8.09872 15.161C7.76986 14.8305 7.50898 14.4375 7.33106 14.0049C7.15315 13.5722 7.06171 13.1083 7.062 12.6398Z",
    fill: "url(#paint0_linear_1151_19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5968 9.07158C10.656 9.07158 10.7148 9.07377 10.7733 9.07668L10.8264 8.0059C10.7503 8.00225 10.6738 8.00043 10.5968 8.00043C9.99301 7.99969 9.39505 8.11933 8.83722 8.35247C8.27939 8.58562 7.77268 8.92769 7.34619 9.35904L8.09847 10.1183C8.42601 9.78629 8.81536 9.52288 9.24411 9.34325C9.67287 9.16361 10.1326 9.07128 10.5968 9.07158Z",
    fill: "url(#paint1_linear_1151_19)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5969 16.2075C10.5377 16.2075 10.4788 16.2075 10.42 16.2027L10.3669 17.2731C10.4432 17.277 10.5199 17.279 10.5969 17.279C11.2004 17.2796 11.7981 17.1599 12.3556 16.9267C12.9132 16.6935 13.4195 16.3513 13.8457 15.92L13.0949 15.1611C12.7673 15.493 12.378 15.7562 11.9493 15.9358C11.5206 16.1154 11.061 16.2077 10.5969 16.2075Z",
    fill: "url(#paint2_linear_1151_19)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 9.69417L13.4838 9.02926C12.6669 8.3616 11.6471 7.99815 10.5959 8.00001V9.07152C11.3078 9.07063 12.003 9.28774 12.59 9.69417Z",
    fill: "url(#paint3_linear_1151_19)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1939 12.6394C15.1945 12.3606 15.1703 12.0824 15.1217 11.808L14.1323 12.5439C14.1323 12.5756 14.1323 12.6073 14.1323 12.6394C14.1326 13.1379 14.029 13.6309 13.8284 14.0864C13.6278 14.542 13.3346 14.9499 12.9678 15.2837L13.6814 16.0798C14.1583 15.6453 14.5394 15.1145 14.7999 14.5218C15.0605 13.9291 15.1947 13.2878 15.1939 12.6394Z",
    fill: "#21A038"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5972 16.2077C10.1032 16.2079 9.61475 16.1034 9.16334 15.9009C8.71197 15.6984 8.30774 15.4025 7.97685 15.0324L7.18848 15.7523C7.61893 16.2337 8.14482 16.6184 8.73204 16.8814C9.31927 17.1444 9.95471 17.28 10.5972 17.2792V16.2077Z",
    fill: "url(#paint4_linear_1151_19)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22651 9.99505L7.51322 9.19897C7.03621 9.6334 6.65501 10.1642 6.39432 10.7569C6.13363 11.3495 5.99929 11.9909 6 12.6394H7.062C7.06178 12.1409 7.16533 11.6479 7.36594 11.1924C7.56654 10.7368 7.85973 10.3289 8.22651 9.99505Z",
    fill: "url(#paint5_linear_1151_19)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7682 13.8198V16H17.6274V9H19.753C21.7701 9 22.6274 9.79068 22.6274 11.3707C22.6274 13.0004 21.6237 13.8198 19.753 13.8198H18.7682ZM18.7682 10.1508V12.669H19.8399C20.8985 12.669 21.4462 12.2893 21.4462 11.3394C21.4462 10.4796 20.9699 10.1495 19.8589 10.1495L18.7682 10.1508Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9842 11.4345C23.2859 11.1965 23.8366 11 24.6268 11C25.9665 11 26.6274 11.4836 26.6274 12.7381V15.9232H25.6182V15.0542C25.3979 15.6134 24.8375 16 24.1036 16C23.177 16 22.6274 15.4497 22.6274 14.5038C22.6274 13.4031 23.3889 13.0945 24.5167 13.0945H25.5535V12.8829C25.5535 12.1977 25.2422 11.9849 24.6268 11.9849C23.7828 11.9849 23.2967 12.3325 22.9854 12.8438L22.9842 11.4345ZM25.5523 14.2192V13.8287H24.6448C24.0114 13.8287 23.7085 13.9547 23.7085 14.3879C23.7085 14.7544 23.9647 14.9862 24.4425 14.9862C25.1668 14.9862 25.5068 14.5516 25.5523 14.2192Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6274 11H27.9235L29.2843 14.4295L30.3963 11H31.6274L29.642 16.5306C29.2039 17.7299 28.7581 18 28.1023 18C27.7939 18 27.4543 17.91 27.3078 17.7808V16.6898C27.4676 16.8467 27.6808 16.9364 27.904 16.9404C28.2604 16.9404 28.5287 16.7002 28.7179 16.0268L26.6274 11Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 37,
    height: 24,
    rx: 2,
    stroke: "black",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1151_19",
    x1: 7.56123,
    y1: 15.7862,
    x2: 6.38171,
    y2: 12.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1151_19",
    x1: 7.64941,
    y1: 9.5485,
    x2: 10.6449,
    y2: 8.41748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1151_19",
    x1: 10.2969,
    y1: 16.6323,
    x2: 13.6794,
    y2: 15.8752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1151_19",
    x1: 10.375,
    y1: 8.35888,
    x2: 13.2689,
    y2: 9.24368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1151_19",
    x1: 7.45488,
    y1: 15.6219,
    x2: 10.6068,
    y2: 16.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1151_19",
    x1: 6.39563,
    y1: 12.7691,
    x2: 7.67849,
    y2: 9.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberpay2);
export default __webpack_public_path__ + "static/media/sberpay2.99edfab303ecb8dbd22487dfd76fdb95.svg";
export { ForwardRef as ReactComponent };